module.exports = __webpack_public_path__ + "img/834678b292ffa4656da6be8b02f5512f.png";